export enum ADVANCED_STYLES {
    /**
     * @value Use CSS and HTML code to modify the site. These are advanced options and should be used knowingly. Changes will be saved only after saving the style. We recommend using a code editor software like Visual Code, Atom or Notepad++ to edit the code. Only use the fields below to paste your code, they are not meant to be a development environment. We also recommend saving the code elsewhere, preferably on a private repository.
     */
    ADVANCED_WARNING = 'ADMIN.INSTANCE_STYLE.ADVANCED_WARNING',
    /**
     * @value Custom code
     * @description Text to be displayed on the button that will display the custom code associated to the current site
     */
    CUSTOM_CODE = 'ADVANCED_STYLES.CUSTOM_CODE',
    /**
     * @value This is an advanced option. You are responsible for any CSS code you are writing; make sure you know what you are doing as it may generate unexpected side-effects. LumApps will not maintain or support this customization, as the product markup may change without notice
     */
    CUSTOM_CSS_WARNING = 'ADMIN.INSTANCE_STYLE.CUSTOM_CSS_WARNING',
    /**
     * @value This is an advanced option. LumApps declines any responsibility if malicious JavaScript code is added in this field by an administrator.
     */
    CUSTOM_JAVASCRIPT_WARNING = 'ADMIN.INSTANCE_STYLE.CUSTOM_JAVASCRIPT_WARNING',
    /**
     * @value Edit custom code
     * @description Text to display when editing custom code
     */
    EDIT_CUSTOM_CODE = 'ADVANCED_STYLES.EDIT_CUSTOM_CODE',
    /**
     * @value Stylesheet (root)
     */
    INSTANCE_CSS_ROOT = 'ADMIN_INSTANCE-THEME_CSS_ROOT',
    /**
     * @value Site theme
     */
    INSTANCE_CSS_THEME = 'ADMIN_INSTANCE-THEME',
    /**
     * @value Head tag (HTML)
     */
    INSTANCE_HEAD = 'ADMIN_INSTANCE-HEAD',
    /**
     * @value Style
     */
    INSTANCE_STYLE = 'ADMIN.NAV.INSTANCE_STYLE',
    /**
     * @value Unsaved changes, save by clicking ✓
     */
    UNSAVED_CHANGES = 'ADVANCED_STYLES.UNSAVED_CHANGES',
}
